module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Light-90f4cc5faaa7a4a2fd7ad13c596941d7.ttf";